import http from 'axios'
import config from '@/config'
import lib from '@/library'

export default {
  get,
  pssitenav,
  totedailyracecard,
  toteraceresult,
  toteMeeting,
  toteRace,
  toteRp,
  toteRc,
  toteMr,
  psbonav,
  bonavigationlistextended,
  scoreboardevents,
  psevent,
  lnbscoreboardupcomingeventlist,
  psheadline,
  evenuemarketbyids,
  selectionsforpricetype,
  eventmarketgroupsconfig,
  psmg,
  psstreams,
  marketsbyselections,
  psParams,
  psCoreParams
}

function pssitenav (paramsMap) {
  return get('pssitenav', [
    'language'
  ], paramsMap)
}

function totedailyracecard (paramsMap) {
  return get('totedailyracecard', [
    'idmmbusinessunit',
    'region',
    'language',
    'date'
  ], paramsMap)
}

function toteraceresult (paramsMap) {
  return get('toteraceresult', [
    'language',
    'idtgrace'
  ], paramsMap)
}

function toteMeeting (paramsMap) {
  return get('totemeeting', [
    'language',
    'idtgmeeting'
  ], paramsMap)
}

function toteRace (paramsMap) {
  return get('toterace', [
    'language',
    'idtgrace'
  ], paramsMap)
}

function toteRp (paramsMap) {
  return get('toterp', [
    'language',
    'idtgrace'
  ], paramsMap)
}

function toteRc (paramsMap) {
  return get('toterc', [
    'language',
    'idtgrace'
  ], paramsMap)
}

function toteMr (paramsMap) {
  return get('totemr', [
    'language',
    'idtgmeeting'
  ], paramsMap)
}

function psbonav (paramsMap) {
  return get('psbonav', [
    'region',
    'language',
    'idfwbonavigation'
  ], paramsMap)
}

function bonavigationlistextended (paramsMap) {
  return get('bonavigationlistextended', [
    'region',
    'language',
    'idfwbonavigation'
  ], paramsMap)
}

function scoreboardevents (paramsMap) {
  return get('ngscoreboardevents', [
    'language',
    'eventsperpage',
    'page',
    'maxnumofselectionsperevent',
    'addfixedmarkets',
    'showupcomingonly',
    'showupcomingprematchmarkets',
    'flags'
  ], paramsMap)
}

function psevent (paramsMap) {
  return get('psevent', [
    'language',
    'region',
    'isliveevent',
    'idfoevent'
  ], paramsMap)
}

function lnbscoreboardupcomingeventlist (paramsMap) {
  return get('lnbscoreboardupcomingeventlist', [
    'language',
    'period',
    'withopenmarkets',
    'limit'
  ], paramsMap)
}

function psheadline (paramsMap) {
  return get('psheadline', [
    'region',
    'language'
  ], paramsMap)
}

function evenuemarketbyids (paramsMap) {
  return get('evenuemarketbyids', [
    'language',
    'idfomarkets'
  ], paramsMap)
}

function selectionsforpricetype (paramsMap) {
  return get('selectionsforpricetype', [
    'language',
    'pricetype',
    'ids'
  ], paramsMap)
}

function eventmarketgroupsconfig (paramsMap) {
  return get('eventmarketgroupsconfig', [
    'region'
  ], paramsMap)
}

function psmg (paramsMap) {
  return get('psmg', [
    'language',
    'idfwmarketgroup'
  ], paramsMap)
}

function psstreams (paramsMap) {
  return get('psstreams', [
    'idfoevent',
    'streamtype'
  ], paramsMap)
}

function marketsbyselections (paramsMap) {
  return get('marketsbyselections', [
    'language',
    'idfoselections'
  ], paramsMap)
}

function psParams (paramsMap) {
  return get('psParams', [
    'idmmbusinessunit',
    'csvlist'
  ], paramsMap)
}

function psCoreParams (paramsMap) {
  return get('pscoreparams', [
    'iddcapplication',
    'csvlist'
  ], paramsMap)
}

function get (generator, paramsList, paramsMap) {
  paramsMap = paramsMap || {}

  if (Array.isArray(paramsList)) {
    if (paramsMap) {
      replaceInArray(paramsList, paramsMap)
    }

    return http.get(createGeneratorUrl(generator, paramsList))
  }
}

// function get (generator, paramsList, paramsMap) {
//   paramsMap = paramsMap || {}
//
//   if (Array.isArray(paramsList)) {
//     if (paramsMap) {
//       replaceInArray(paramsList, paramsMap)
//     }
//
//     return new Promise(function (resolve, reject) {
//       var xhr = new XMLHttpRequest()
//       xhr.open('GET', createGeneratorUrl(generator, paramsList))
//
//       xhr.onload = function () {
//         if (this.status >= 200 && this.status < 300) {
//           resolve({ 'data': JSON.parse(xhr.response) })
//         } else {
//           reject(new Error({
//             status: this.status,
//             statusText: xhr.statusText
//           }))
//         }
//       }
//       xhr.send()
//     })
//
//     // return http.get(createGeneratorUrl(generator, paramsList))
//   }
// }

function createGeneratorUrl (generator, params) {
  return lib.core.url.joinSegments([
    config.app.contentServerHostname,
    'cache',
    generator
  ].concat(params)).concat('.' + config.kansas.responseType)
}

function replaceInArray (array, map) {
  map.idmmbusinessunit = config.app.businessUnit
  map.region = config.app.region

  if (!map.language) {
    map.language = config.app.language
  }

  for (var i = 0; i < array.length; i++) {
    for (var variable in map) {
      if (map.hasOwnProperty(variable)) {
        if (array[i] === variable) {
          array[i] = map[variable]
          break
        }
      }
    }
  }
  return array
}



// WEBPACK FOOTER //
// ./src/library/kansas/index.js